import { useQuery } from '@tanstack/react-query';

import { getOffersTotal } from '../../common/api/clients/gateway.api';
import { queries } from '../../common/api/queryKeys/queries';

export const useOfferPaginationTotals = ({ searchQuery, supplierIds, customerIds, offerTabs, tapToOfferStateMap }) => {
    const fetchTotals = ({ searchQuery, supplierIds, customerIds }) => {
        return Promise.all(
            offerTabs.map((tab) =>
                getOffersTotal({
                    searchQuery,
                    supplierIds,
                    customerIds,
                    states: tapToOfferStateMap[tab],
                })
            )
        )
            .then((values) => values.map((value) => value.count))
            .then((offersTotals) => {
                return offerTabs.reduce((acc, value, index) => {
                    acc[value] = offersTotals[index];
                    return acc;
                }, {});
            });
    };

    return useQuery({
        queryKey: queries.offers.totals({
            searchQuery,
            supplierIds,
            customerIds,
        }).queryKey,
        queryFn: () =>
            fetchTotals({
                searchQuery,
                supplierIds,
                customerIds,
            }),
        refetchOnWindowFocus: false,
    });
};
